import { render, staticRenderFns } from "./verifyRegistration.vue?vue&type=template&id=2a47082a&scoped=true"
import script from "./verifyRegistration.vue?vue&type=script&lang=js"
export * from "./verifyRegistration.vue?vue&type=script&lang=js"
import style0 from "./verifyRegistration.vue?vue&type=style&index=0&id=2a47082a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a47082a",
  null
  
)

export default component.exports